export const ambassadorPerks = [
  'Join an exclusive community of fellow décor enthusiasts',
  'Feature & promote your knack for interior decorating on your personal Showcase Page',
  'Enhance your visibility and following on social media',
  'Earn points that can be redeemed for home furnishing gift cards',
];
